import getArrivalDateLabel from "@/app/ec/product/[basePath]/vendor-options/getArrivalDateLabel";
import { StockedState } from "@/app/ec/product/[basePath]/vendor-options/getStockedMessage";
import { getOfferStockedState } from "./sellerOptions";
import styles from "./shippingEstimate.module.scss";

// "Stocked | Delivery from CA by Sep 23". Without a delivery date, or with `showDeliveryDate` off, how long the
// seller takes to ship instead.
export default function ShippingEstimate({ vendorOption, showDeliveryDate = true }: ShippingEstimateProps) {
  const state = getOfferStockedState(vendorOption);
  const status = STATUSES[state];
  const deliveryDate = showDeliveryDate ? getArrivalDateLabel(vendorOption, "MMM D") : null;
  const from = vendorOption.vendorRegion ? ` from ${vendorOption.vendorRegion}` : "";

  return (
    <span className={styles.ShippingEstimate}>
      {status && (
        <>
          <span className={styles[status.tone]}>{status.label}</span>
          {" | "}
        </>
      )}
      {state === StockedState.BACKORDERED ? (
        `Ships${from}`
      ) : deliveryDate ? (
        <>
          Delivery{from} by <strong>{deliveryDate}</strong>
        </>
      ) : (
        <>
          <strong>{formatBusinessDays(vendorOption.shippingTime)}</strong> until ready to ship{from}
        </>
      )}
    </span>
  );
}

function formatBusinessDays(days: number): string {
  if (days >= 30) {
    return "30+ business days";
  }
  return `${days} business ${days === 1 ? "day" : "days"}`;
}

const STATUSES: Record<StockedState, { label: string; tone: "success" | "error" } | null> = {
  [StockedState.STOCKED]: { label: "Stocked", tone: "success" },
  [StockedState.LONG_HANDLING_TIME]: { label: "Long Handling Time", tone: "error" },
  [StockedState.BACKORDERED]: { label: "Backordered", tone: "error" },
  [StockedState.UNKNOWN]: null,
};

interface ShippingEstimateProps {
  vendorOption: VendorOptionState;
  showDeliveryDate?: boolean;
}
